import React, { createContext, useContext, useState, useEffect } from "react";

const PortalContext = createContext();

const STORAGE_KEY = "seiko-ems-portal-mode";

export function PortalProvider({ children, user }) {
  const [portalMode, setPortalModeState] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) || "manager";
    } catch {
      return "manager";
    }
  });

  const isActualAdmin = user?.role === "admin";

  const setPortalMode = (mode) => {
    setPortalModeState(mode);
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch {}
  };

  const isManagerView = isActualAdmin && portalMode === "manager";

  return (
    <PortalContext.Provider value={{ portalMode, setPortalMode, isManagerView, isActualAdmin }}>
      {children}
    </PortalContext.Provider>
  );
}

export function usePortal() {
  const ctx = useContext(PortalContext);
  if (!ctx) throw new Error("usePortal must be used within a PortalProvider");
  return ctx;
}
